import React, { useState, useEffect } from 'react';

function StatusCounter({ contract }) {
  const [stats, setStats] = useState({
    soldPixels: 0,
    availablePixels: 1000000,
    percentage: 0.0000
  });

  useEffect(() => {
    const fetchStats = async () => {
      if (!contract) return;
      
      try {
        // Get the raw pixel count from the contract
        const totalMinted = await contract.getTotalMintedPixels();
        
        // The value returned might be the number of cells/blocks rather than actual pixels
        // Based on your observation, we need to multiply by 100 to get the actual pixel count
        const rawValue = parseInt(totalMinted.toString());
        const soldPixels = rawValue * 100; // Convert from blocks to pixels
        
        const totalPixels = 1000000; // 1000×1000
        const availablePixels = totalPixels - soldPixels;
        
        const percentage = (soldPixels / totalPixels) * 100;
        
        setStats({
          soldPixels,
          availablePixels,
          percentage: percentage.toFixed(2) // 2 decimal places
        });
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    fetchStats();
    
    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, [contract]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8f9fa',
      padding: '10px',
      borderRadius: '4px',
      marginBottom: '15px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      width: '100%'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: '20px'
      }}>
        <div style={{ fontWeight: 'bold', marginRight: '5px' }}>Sold:</div>
        <div>{stats.soldPixels.toLocaleString()} pixels</div>
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: '20px'
      }}>
        <div style={{ fontWeight: 'bold', marginRight: '5px' }}>Available:</div>
        <div>{stats.availablePixels.toLocaleString()} pixels</div>
      </div>
      
      <div style={{
        width: '150px',
        height: '12px',
        backgroundColor: '#e0e0e0',
        borderRadius: '6px',
        overflow: 'hidden',
        marginRight: '10px'
      }}>
        <div style={{
          width: `${stats.percentage}%`,
          height: '100%',
          backgroundColor: '#4CAF50',
          borderRadius: '6px'
        }} />
      </div>
      
      <div>{stats.percentage}% sold</div>
    </div>
  );
}

export default StatusCounter;